import React from 'react'
import Owner from "../models/Owner";

export default function Footer() {
  const owner = Owner.instance
  return (
    /* container */
    <div className="container-fluid">

      {/* footer */}
      <footer>
        {/* copyright */}
        <div>© 2020 {owner.fullName} ({owner.pseudo})</div>
        {/* author ( Please! Do not delete it. You are awesome! :) */}
        <div>Template author:&#160; <a href="https://themeforest.net/user/millerdigitaldesign"
                                       target="_blank" rel="noopener noreferrer">Nazar Miller</a></div>
      </footer>
      {/* footer end */}

    </div>
    /* container end */
  )
}
